import {useMutation, useQueryClient} from '@tanstack/react-query'
import {addValid} from '../../../../store/message'
import {useActionDispatch} from '../../../utils'
import {UserFriendlyError} from '../../../../model/Error'
import {trustedSourceKeys} from "./trustedSource.keys";
import {deleteTrustedSource} from "../../../../data/admin/trustedSources/deleteTrustedSource";


export const useDeleteTrustedSource = () => {
  const valid = useActionDispatch(addValid)
  const queryClient = useQueryClient()

  const queryReturn = useMutation({
    mutationFn: async (id: number) => {
      const {ok} = await deleteTrustedSource(id)
      if (!ok) {
        throw new UserFriendlyError('error', 'La suppression de la pièce justificative a échoué')
      }
      return null
    },

    onSuccess: (_data) => {
      valid('La pièce justificative a été supprimée')
      queryClient.refetchQueries({
        queryKey: trustedSourceKeys.all
      })
    },
  })

  return queryReturn
}
